import React, { useState, useEffect } from 'react';
import { useAppSelector } from "../../../utils/Hooks";
import { useLocation, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.extend(weekOfYear);

interface RangeSearchProps {
    url: string;
    userVisible: boolean;
}

const RangeSearch: React.FC<RangeSearchProps> = ({ url, userVisible }) => {
    const navigate = useNavigate();
    const { search } = useLocation();

    const [week, setWeek] = useState<number>(dayjs().week());
    const [user, setUser] = useState<string>('0');

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        setWeek(parseInt(urlParams.get("week") || `${dayjs().week()}`, 10));
        setUser(urlParams.get("user") || '0');
    }, []);

    const handleSearch = () => {
        const searchParams = new URLSearchParams();
        searchParams.set("week", week.toString());
        if (userVisible) {
            searchParams.set("user", user);
        }
        const newUrl = `${url}?${searchParams.toString()}`;
        navigate(newUrl);
    };

    const usersState = useAppSelector(state => state.users);
    const userOptions = [{ value: '0', label: 'Kõik' }, ...usersState.users
        .filter((user) => user.accountant != 1)
        .map((user) => ({
            value: user.id.toString(),
            label: `${user.firstname} ${user.lastname}`,
        }))];

    return (
        <form>
            <div className="filter clear" style={{ width: '99%' }}>
                <div className="content" style={{ width: '100%' }}>
                    <p>
                        <span style={{ display: 'inline-flex' }}>
                            <label><strong>Nädal:</strong></label>
                            <select value={week} onChange={(e) => setWeek(parseInt(e.target.value, 10))}>
                                {[...Array(dayjs().week())].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>Nädal {i + 1}</option>
                                ))}
                            </select>
                        </span>
                        {userVisible && (
                            <>
                                &nbsp;&nbsp;&nbsp;
                                <label><strong>Kasutaja:</strong></label>
                                <select value={user} onChange={(e) => setUser(e.target.value)}>
                                    {userOptions.map(option => (
                                        <option key={option.value} value={option.value}>{option.label}</option>
                                    ))}
                                </select>
                            </>
                        )}
                    </p>
                </div>
                <p className="action">
                    <button type="button" onClick={handleSearch}><span><strong>Otsi</strong></span></button>
                </p>
            </div>
        </form>
    );
};

export default RangeSearch;